import { appsCoreApiAuthCsrf } from '@/lib/api/generated/endpoints'

const SAFE_FALLBACK = '/projects'

/**
 * Validate redirect param: must be a same-origin relative path.
 * Rejects absolute URLs, protocol-relative URLs, and pseudo-protocols.
 *
 * Brief §1 demands "redirect param validation" — without this, the login flow
 * is exploitable via ?redirect=https://evil.com.
 */
export function safeRedirect(raw: string | null | undefined): string {
  if (typeof raw !== 'string' || raw.length === 0) return SAFE_FALLBACK
  if (!raw.startsWith('/')) return SAFE_FALLBACK
  if (raw.startsWith('//')) return SAFE_FALLBACK // protocol-relative
  return raw
}

function getCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp(`(^|; )${name}=([^;]*)`))
  return match ? decodeURIComponent(match[2] ?? '') : null
}

/**
 * Django sets the CSRF cookie on responses to GET endpoints decorated with
 * @ensure_csrf_cookie. On a cold session, the first user action is often
 * POST /auth/login — without prior GET, customFetch's getCookie('csrftoken')
 * returns null → header omitted → CSRF middleware rejects with 403.
 *
 * Call this before any POST/PUT/DELETE on a fresh session (login + maybe app
 * mount via beforeLoad in __root.tsx).
 */
export async function ensureCsrf(): Promise<void> {
  if (getCookie('csrftoken')) return
  await appsCoreApiAuthCsrf()
}
